export default "__VITE_ASSET__Dno2jtfB__"